// Merge only calculated fields into a full editable record for legacy cities.
// Search summaries must never replace correspondence, evidence, or seen state.
export function applyLegacyViolationSummary(record, summary, city) {
  if (city?.isFrontendV2Ready || !record || summary?.id !== record.id || summary?.city?.id !== city?.id) return;
  const computed = summary.violations;
  if (!computed) return;
  record.data.violations = {
    ...record.data.violations,
    status: computed.status, activeListingCount: computed.activeListingCount,
    licenseStatus: computed.licenseStatus, licenseWorkflowStatus: computed.licenseWorkflowStatus
  };
}
